import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  DimensionRecommendationsMeta,
  WidgetDefinition,
} from '../../../../shared/types/widget';
import { CircleArrowDown } from '../../../../assets/icons/CircleArrowDown';

interface DimensionRecommendationsProps {
  definition: WidgetDefinition;
  content: DimensionRecommendationsMeta;
}

function DimensionRecommendations({
  definition,
  content,
}: DimensionRecommendationsProps) {
  const { t } = useTranslation();

  return (
    <div className="flex h-full flex-col">
      <img
        src={import.meta.env.VITE_IMAGE_BASE_URL + content?.meta?.image}
        alt="Recommendations thumbnail"
        className="rounded-2xl"
      />
      {content?.data?.link == null ? (
        <div className="flex h-full w-full items-center justify-center p-4">
          {t('RECOMMENDATIONS_EMPTY')}
        </div>
      ) : (
        <div className="flex flex-col gap-y-2 pt-4">
          <p className="text-grey-900 text-xl font-bold">
            {t('RECOMMENDATIONS')}
          </p>
          <p className="text-grey-700 text-lg">
            {t('RECOMMENDATIONS_FILE_DESCRIPTION')}
          </p>
          <Link
            to={content?.data?.link}
            target="_blank"
            className="flex cursor-pointer items-center gap-x-2 text-sm font-medium text-blue-700"
          >
            {t('DOWNLOAD')} {t('FILE')}{' '}
            <CircleArrowDown className="w-6 stroke-blue-700" />
          </Link>
        </div>
      )}
    </div>
  );
}

export default DimensionRecommendations;
